import React from 'react';
import {useMutation} from '@apollo/client/react';
import {EditLocationAlt} from '@mui/icons-material';
import {Button} from '@mui/material';
import ButtonDialog from './ButtonDialog';
import {useResourceContext} from 'components/record/ResourceContext';
import {useListContext} from 'components/list/ListContext';
import {useDialogContext} from 'components/dialog/DialogContext';
import QUERIES from 'services/gqlQueries';
import {toast} from 'react-toastify';

const BulkUpdateTracksConfirm = ({onSuccess}: {onSuccess: () => void}) => {
  const {params} = useResourceContext();
  const {close} = useDialogContext();
  const {selected: ids} = useListContext();
  const [mutate, {loading}] = useMutation<{bulkUpdateCompetitorTracks: boolean}>(QUERIES.bulkUpdateCompetitorTracksCompetitor);

  const handleConfirm = () => {
    mutate({variables: {...params, ids}})
      .then((res) => {
        if (res.data?.bulkUpdateCompetitorTracks) {
          toast.success('Track update was requested for the selected competitors.');
          close();
          onSuccess();
        }
      })
      .catch((error: Error) => {
        if (error.message) {
          toast.error(error.message);
        }
      });
  };

  return (
    <Button variant="contained" onClick={handleConfirm} disabled={loading}>
      {loading ? 'Loading...' : 'Confirm'}
    </Button>
  );
};

const BulkUpdateTracks = () => {
  const {resource} = useResourceContext();
  const {refetch, setSelected} = useListContext();

  const onSuccess = () => {
    setSelected([]);
    if (typeof refetch === 'function') {
      refetch();
    }
  };

  return (
    <ButtonDialog
      buttonLabel="Update tracks"
      variant="text"
      maxWidth="sm"
      startIcon={<EditLocationAlt />}
      dialogTitle={`Update tracks for selected ${resource}s`}
      primaryButton={<BulkUpdateTracksConfirm onSuccess={onSuccess} />}
    >
      Request a track update for all selected competitors? This will send their ids to the server.
    </ButtonDialog>
  );
};

export default BulkUpdateTracks;
